import { FormControl, Grid, TextField } from '@mui/material';
import { Controller, FieldError } from 'react-hook-form';

import { GridSizeType, SxPropsThemeType, gridSize } from '@/shared/constants';

export type CustomNumberFieldProps = {
  label: string;
  error: FieldError | undefined;
  helperText: React.ReactNode;
  disabled?: boolean;
  shrink?: boolean;
  required?: boolean;
  min?: number;
  max?: number;
  step?: number;

  size?: GridSizeType;

  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;

  control: any;
  name: string;
  defaultValue?: string | number;
  onChangeValue?: (value: any) => void;
  sxInputText?: SxPropsThemeType;

  limitDigits?: number;
  isPositive?: boolean;
  onlyInteger?: boolean;

  textPlaceholder?:string
};

const CustomNumberTextField: React.FC<CustomNumberFieldProps> = ({
  error,
  helperText,
  label,
  disabled = false,
  required = true,
  shrink,
  size = gridSize,
  max,
  min = 1,
  step = 1,

  startAdornment,
  endAdornment,

  control,
  name,
  defaultValue,
  onChangeValue,
  sxInputText,
  limitDigits,
  isPositive = true,
  onlyInteger = false,
  textPlaceholder,
}) => {

  // const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
  //   if(onlyInteger){
  //     if (['e', 'E', '-', '.', ','].includes(event.key)) {
  //       event.preventDefault();
  //     }
  //   }else{
  //     // Bloquear teclas no deseadas (e, E, -, .)
  //     if (['e', 'E', '-', '.'].includes(event.key)) {
  //       event.preventDefault();
  //     }
  //   }
  // };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const { key } = event;

    if (['e', 'E', '-', ','].includes(key)) {
      event.preventDefault();
      return;
    }

    if (onlyInteger && key === '.') {
      event.preventDefault();
    }

    // Evitar más de un punto decimal
    const input = event.currentTarget.querySelector('input');
    if (key === '.' && input?.value.includes('.')) {
      event.preventDefault();
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>) => {
    // Obtener el contenido pegado
    const pasteData = event.clipboardData.getData('Text');

    // Verificar si el contenido pegado es un número positivo
    if (!/^\d+$/.test(pasteData)) {
      event.preventDefault();
    }
  };

  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue ?? 0}
          // disabled={disabled}
          render={({ field }) => {
            // const onChange = (e: any) => {

            //   const value = e.target.value;
            //   if (disabled) return;
            //   if (limitDigits && value.length > limitDigits) return;
            //   field.onChange(e);
            //   if (onChangeValue) onChangeValue(e.target.value);
            // };
            const onChange = (e: any) => {
              let value = e.target.value;

              // Evitar entrada si está deshabilitado
              if (disabled) return;

              if (limitDigits && value.length > limitDigits) return;

              // Validar y limitar a dos decimales
              if (!onlyInteger) {
                // Permitir vacío o número válido
                if (value === '' || /^[0-9]*\.?[0-9]{0,2}$/.test(value)) {
                  field.onChange(e);
                  if (onChangeValue) onChangeValue(value);
                }
              } else {
                // Si solo se permiten enteros
                if (/^\d*$/.test(value)) {
                  field.onChange(e);
                  if (onChangeValue) onChangeValue(value);
                }
              }
            };


            return (
              <TextField
                fullWidth
                disabled={disabled}
                onKeyDown={isPositive ? handleKeyDown : undefined}
                onPaste={isPositive ? handlePaste : undefined}
                label={label}
                type={disabled ? 'tel' : 'number'}
                variant="outlined"
                InputProps={{
                  inputProps: {
                    min,
                    ...(max && { max }),
                    step,
                  },
                  startAdornment: startAdornment ?? null,
                  endAdornment: endAdornment ?? null,
                }}
                InputLabelProps={{ ...(shrink && { shrink: true }) }}
                {...field}
                error={!!error}
                helperText={helperText}
                required={required}
                onChange={onChange}
                autoComplete="off"
                autoCorrect='off'
                placeholder={!!textPlaceholder?textPlaceholder:""}
                // disabled style

                inputProps={{
                  readOnly: disabled,
                  onWheel: (e: React.WheelEvent<HTMLInputElement>) => {
                    e.preventDefault();
                  },
                }}
                sx={{
                  ...(disabled
                    ? {
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "rgba(0, 0, 0, 0.035)",
                        cursor: "not-allowed",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(239, 239, 239, 0.16)",
                          borderStyle: "dashed",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(0, 0, 0, 0.22)",
                        },
                      },
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "rgba(15, 23, 42, 0.88)",
                        color: "rgba(15, 23, 42, 0.88)",
                        fontWeight: 600,
                        cursor: "not-allowed",
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "text.secondary",
                        fontWeight: 500,
                      },
                    }
                    : {
                      "& .MuiOutlinedInput-root": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#d3d3d3",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#9395ec",
                        },
                      },
                    }),
                  ...sxInputText,
                }}
              />
            );
          }}
        ></Controller>
      </FormControl>
    </Grid>
  );
};

export default CustomNumberTextField;
